module.exports = "#define GLSLIFY 1\n  gl_FragColor = linearToOutputTexel( gl_FragColor );\n"